export const NavigationAuditRegexEndpoints = {
  GET_ALL: '/api/admin/navigations/auditregex',
  BY_NAVIGATION: (navId: number) => `/api/admin/navigations/${navId}/auditregex`,
  BY_ID: (navId: number, regexId: number) =>
    `/api/admin/navigations/${navId}/auditregex/${regexId}`,
};
